import React from 'react';
import { Card, CardContent } from '@mui/material';
import ListadoPersonaIndividual from './ListadoPersonaIndividual';
import PersonaJuridica from './PersonaJuridica';

const DatosDelPropietario= ({datosGeneralesDeSolicitud, obtenerDocumentoAdjunto}) => (
  <Card>
      <CardContent>
          {datosGeneralesDeSolicitud?.solicitudPersonaJuridica?.length > 0 ? ( <PersonaJuridica datosGeneralesDeSolicitud={datosGeneralesDeSolicitud} obtenerDocumentoAdjunto={obtenerDocumentoAdjunto} /> )
          : ( <ListadoPersonaIndividual datosGeneralesDeSolicitud={datosGeneralesDeSolicitud} /> ) }
    </CardContent>
  </Card>
);

export default DatosDelPropietario;